import React from 'react'

const Loader = props => {
    return (
        <div className="mdn-Spinner">
            <i className="mdn-Icon-claro mdn-Icon--lg"></i>
        </div>
    )
}

export default Loader;